import {facebookMessageConfirmOrderActions as actions} from './_actions'
import {facebookMessageConfirmOrderInitialState} from './_initstate'

export const FacebookMessageConfirmOrderReducer = (state, action) => {
  switch (action.type) {

    case actions.MESSAGE_CONFIRM_LIST_UPDATE:
      return {
        ...state,
        pages: {
          ...state.pages,
          list: action.payload?.list,
        },
      }

    case actions.MESSAGE_CONFIRM_LOADING_UPDATE:
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: action.payload?.loading,
        },
      }

    case actions.MESSAGE_CONFIRM_MODAL_STATUS:
      return {
        ...state,
        modal: {
          ...state.modal,
          confirmStatus: {
            ...state.modal.confirmStatus,
            data: action.payload.data,
            open: action.payload.open,
          },
        },
      }
    case actions.MESSAGE_CONFIRM_GET_DETAIL:
      return {
        ...state,
        isDataLoaded: true,
        detail: {
          ...state.detail,
          content_message: action.payload.content_message || state.detail.samples,
          status: action.payload.status,
        },
        livestreamDetail: action.payload.livestream_content_message !== undefined
          ? {
              ...state.livestreamDetail,
              content_message: action.payload.livestream_content_message || state.livestreamDetail.samples,
              status: action.payload.livestream_status ?? state.livestreamDetail.status,
            }
          : state.livestreamDetail,
      }
    case actions.MESSAGE_CONFIRM_CHANGE_MESSAGE:
      return {
        ...state,
        detail: {
          ...state.detail,
          content_message: action.payload,
          reset: false
        }
      }
    case actions.MESSAGE_CONFIRM_CHANGE_STATUS:
      return {
        ...state,
        detail: {
          ...state.detail,
          status: action.payload
        }
      }
    case actions.VALIDATE_MESSAGE_CONFIRM:
      return {
        ...state,
        detail: {
          ...state.detail,
          validate: action.payload
        }
      }
    case actions.MESSAGE_CONFIRM_RESET_CONTENT:
      return {
        ...state,
        detail: {
          ...state.detail,
          content_message: state.detail.samples,
          reset: true
        }
      }
    case actions.MESSAGE_CONFIRM_LIVESTREAM_CHANGE_MESSAGE:
      return {
        ...state,
        livestreamDetail: {
          ...state.livestreamDetail,
          content_message: action.payload,
          reset: false,
        },
      }
    case actions.MESSAGE_CONFIRM_LIVESTREAM_CHANGE_STATUS:
      return {
        ...state,
        livestreamDetail: {
          ...state.livestreamDetail,
          status: action.payload,
        },
      }
    case actions.MESSAGE_CONFIRM_LIVESTREAM_RESET_CONTENT:
      return {
        ...state,
        livestreamDetail: {
          ...state.livestreamDetail,
          content_message: state.livestreamDetail.samples,
          reset: true,
        },
      }
    case actions.VALIDATE_LIVESTREAM_MESSAGE:
      return {
        ...state,
        livestreamDetail: {
          ...state.livestreamDetail,
          validate: action.payload,
        },
      }
    default:
      throw new Error()
  }
}
